import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Exports',
		url: '/exports',
		icon: 'globe',
	}
];

export default class Exports extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalExport')} size="sm" color="primary">
						<i className="fa fa-globe"/>&nbsp;&nbsp;Add Export
					</Button>
				</Framework.Components.PageBar>

				<Collections.Exports
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Exports"
					object={Objects.Export}
					history={this.props.history}
					toggle={this.state['modalExport']}
					reportClose={this.reportClose('modalExport')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}

